(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game-wager/assets/javascripts/randomize-row.js') >= 0) return;  svs.modules.push('/components/numbergames/game-wager/assets/javascripts/randomize-row.js');


'use strict';

const _svs$numbergames = svs.numbergames,
  productMapping = _svs$numbergames.productMapping,
  _svs$numbergames$rule = _svs$numbergames.rules,
  getRules = _svs$numbergames$rule.getRules,
  jokerRules = _svs$numbergames$rule.joker;

function _randomizeArray(numbers, min, max, size) {
  const nonNegativeIntegers = values => values.every(num => Number.isInteger(num) && num >= 0);
  const validRange = (min, max, size) => max - (min - 1) >= size;
  if (!Array.isArray(numbers)) {
    numbers = [];
  }
  numbers = numbers.filter(num => num.manual);
  if (nonNegativeIntegers([min, max, size]) && validRange(min, max, size)) {
    const universe = Array.from({
      length: max - (min - 1)
    }, (_, i) => i + min).filter(n => !numbers.find(number => number.number === n));
    const randomNumbers = svsRandom.getRandomSample(universe, size - numbers.length, false);
    numbers = numbers.concat(randomNumbers.map(n => ({
      number: n,
      manual: false
    })));
    numbers.sort((a, b) => a.number - b.number);
  }
  return numbers;
}

function randomizeRow(board) {
  var _board$level;
  if (productMapping.isJoker(board.productId)) {
    return {
      numbers: jokerRules.getHuxfluxedRow()
    };
  }
  const rules = getRules(board.productId);
  const numbersSize = board.isSystemBoard ? board.systemSize.numbersSize : (_board$level = board.level) !== null && _board$level !== void 0 ? _board$level : rules.numbersMaxLength;
  const extraNumbersSize = board.isSystemBoard ? board.systemSize.extraNumbersSize : rules.numbersExtraMaxLength;
  return {
    numbers: _randomizeArray(board.numbers, 1, rules.numbersMaxValue, numbersSize),
    extraNumbers: _randomizeArray(board.extraNumbers, 1, rules.numbersExtraMaxValue, extraNumbersSize)
  };
}
Object.assign(svs.numbergames.gameWager, {
  randomizeRow,
  _randomizeArray
});

 })(window);